import type { CommunicationParticipant } from '@/api/fe-api/entities/communication';
import { Tooltip } from '@/components/ui/tooltip';

export type CommunicationDetailsParticipantProps = {
  participant: CommunicationParticipant;
};

export function CommunicationDetailsParticipant({
  participant,
}: CommunicationDetailsParticipantProps) {
  if (participant.name && participant.address) {
    return (
      <Tooltip clickToKeepOpen content={participant.address}>
        <span>{participant.name}</span>
      </Tooltip>
    );
  } else if (participant.name) {
    return <span>{participant.name}</span>;
  } else if (participant.address) {
    return <span>{participant.address}</span>;
  } else {
    return <>unknown</>;
  }
}
